import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

function messageFor(err: unknown): string {
  if (err instanceof Error && err.message) return err.message
  return String(err)
}

// The consent flow renders every expected outcome (expired / rate-limited / mismatch / locked /
// copy-updated) as its own screen, so those calls set meta.suppressToast and map the error
// themselves. This global handler is the safety net for genuinely unexpected failures only.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 30,
    },
  },
  queryCache: new QueryCache({
    onError: (err, query) => {
      const meta = query.options.meta as { suppressToast?: boolean } | undefined
      if (meta?.suppressToast) return
      toast.error(messageFor(err))
    },
  }),
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      const meta = mutation.options.meta as { suppressToast?: boolean } | undefined
      if (meta?.suppressToast) return
      toast.error(messageFor(err))
    },
  }),
})
